import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { InputWidthValues } from '../../../../ui/gzInput';

export const templatePackageDeployerForm = document.createElement('template');

templatePackageDeployerForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='package-use-proxy-form-wrapper'>
    <div class='form-section'>
      <gz-form-field id='use-proxy' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
      </gz-form-field>

      <div id='use-proxy-checked-section' class='hidden sub-module-section'>
        <gz-form-field id='server-proxy-form-field' class='sub-module' label='' required>
          <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='port-proxy-form-field' class='sub-module' label='' required>
          <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='username-proxy-form-field' class='sub-module' label=''>
          <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='password-proxy-form-field' class='sub-module' label=''>
          <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}' type="password"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
